import { Box } from '@mantine/core';
import type { FC, PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';
import StepperHeader from '../StepperHeader';
import { CLASS_NAMES } from './classNames';

const Layout: FC<PropsWithChildren> = ({ children }) => {
	return (
		<Box
			className={CLASS_NAMES.page}
			component="main"
			data-testid="stepper-layout"
		>
			<StepperHeader />
			<Box className={CLASS_NAMES.layoutBody}>{children ?? <Outlet />}</Box>
		</Box>
	);
};

export default Layout;
